var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor cache-write" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("Cache Key"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t("Örnek: user_{{contact._id}}_session"),
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.key,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "key", $$v)
              },
              expression: "clone.key",
            },
          }),
          _vm._v(" "),
          _vm._m(0),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("Cache Value"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t("Kaydedilecek değer"),
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.value,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "value", $$v)
              },
              expression: "clone.value",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("Cache Tipi"))),
          ]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.typeOptions,
              idKey: "value",
              labelKey: "label",
              placeholder: _vm.$t("Cache tipini seçin"),
            },
            model: {
              value: _vm.clone.type,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "type", $$v)
              },
              expression: "clone.type",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "help-text" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
            _vm._v(" "),
            _vm.clone.type === "public"
              ? _c("span", [
                  _vm._v(
                    "Public cache'ler tüm modüller tarafından okunabilir ve güncellenebilir."
                  ),
                ])
              : _c("span", [
                  _vm._v(
                    "Private cache'ler sadece oluşturan modül tarafından güncellenebilir. UI'dan manuel güncellenebilir."
                  ),
                ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("Data Type"))),
          ]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.dataTypeOptions,
              idKey: "value",
              labelKey: "label",
              placeholder: _vm.$t("Data tipini seçin"),
            },
            model: {
              value: _vm.clone.dataType,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "dataType", $$v)
              },
              expression: "clone.dataType",
            },
          }),
          _vm._v(" "),
          _vm._m(1),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("Geçerlilik Süresi"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "expires-config" },
          [
            _c("CustomPicker", {
              attrs: {
                items: _vm.expiresModeOptions,
                idKey: "value",
                labelKey: "label",
                placeholder: _vm.$t("Süre tipi"),
              },
              model: {
                value: _vm.clone.expiresAt.mode,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.expiresAt, "mode", $$v)
                },
                expression: "clone.expiresAt.mode",
              },
            }),
            _vm._v(" "),
            _vm.clone.expiresAt.mode === "duration"
              ? _c(
                  "div",
                  { staticClass: "duration-config" },
                  [
                    _c("TiptapEditor", {
                      attrs: {
                        placeholder: _vm.$t("Süre değeri (örn: 24)"),
                        "show-attributes": true,
                        "automation-mode": "",
                      },
                      model: {
                        value: _vm.clone.expiresAt.duration.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone.expiresAt.duration, "value", $$v)
                        },
                        expression: "clone.expiresAt.duration.value",
                      },
                    }),
                    _vm._v(" "),
                    _c("CustomPicker", {
                      attrs: {
                        items: _vm.durationUnitOptions,
                        idKey: "value",
                        labelKey: "label",
                        placeholder: _vm.$t("Birim"),
                      },
                      model: {
                        value: _vm.clone.expiresAt.duration.unit,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone.expiresAt.duration, "unit", $$v)
                        },
                        expression: "clone.expiresAt.duration.unit",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.clone.expiresAt.mode === "timestamp"
              ? _c(
                  "div",
                  { staticClass: "timestamp-config" },
                  [
                    _c("TiptapEditor", {
                      attrs: {
                        placeholder: _vm.$t(
                          "ISO tarih (örn: 2025-12-31T23:59:59.000Z)"
                        ),
                        "show-attributes": true,
                        "automation-mode": "",
                      },
                      model: {
                        value: _vm.clone.expiresAt.timestamp.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone.expiresAt.timestamp, "value", $$v)
                        },
                        expression: "clone.expiresAt.timestamp.value",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "help-text" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Key unique olmalıdır. Aynı key ile tekrar yazarsanız değer güncellenir."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "help-text" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Data tipi sadece UI'da gösterim için kullanılır, validation yapılmaz."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }